export default __webpack_public_path__ + "static/media/copy-v2.75ba2d00.svg";